'use client';

import React, { forwardRef, useRef } from 'react';
import { Send } from 'lucide-react';
import * as SubframeUtils from '../utils';
import { Button } from './Button';
import { TextArea } from './TextArea';

interface ChatInputProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  onSend: (message: string) => void;
  isLoading?: boolean;
}

export const ChatInput = forwardRef<HTMLTextAreaElement, ChatInputProps>(
  ({ className, onSend, isLoading, value, onChange, placeholder, ...props }, ref) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        if (value && !isLoading) {
          onSend(value.toString());
        }
      }
    };

    const handleSendClick = () => {
      if (value && !isLoading) {
        onSend(value.toString());
      }
    };

    return (
      <div
        className={SubframeUtils.twClassNames(
          'flex items-end gap-2 border-t border-neutral-200 bg-white p-4',
          className,
        )}
      >
        <TextArea className="w-full flex-1" disabled={isLoading}>
          <TextArea.Input
            ref={ref}
            className="h-[44px] min-h-[44px] resize-none overflow-hidden"
            placeholder={placeholder || 'Digite sua dúvida...'}
            value={value?.toString()}
            onChange={onChange}
            onKeyDown={handleKeyDown}
            disabled={isLoading}
            {...props}
          />
        </TextArea>
        <Button
          variant="neutral-secondary"
          onClick={handleSendClick}
          disabled={!value || isLoading}
          loading={isLoading}
          iconRight={<Send size={16} />}
          className="h-11 flex-none px-4"
        >
          Enviar
        </Button>
      </div>
    );
  },
);
